var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import id from "@irati/utils/id";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { Hidden } from "@irati/ui/src/FormItem";
import Validation from "@irati/utils/validation";
import UploadImage from "./UploadImage/UploadImage";
import UploadedImage from "./UploadImage/UploadedImage";
import SectionHeading from "./styled/SectionHeading";
import ErrorWrapper from "./styled/ErrorWrapper";
var CardImageUpload = /** @class */ (function (_super) {
    __extends(CardImageUpload, _super);
    function CardImageUpload() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardImageUpload.prototype.schema = function (formatMessage) {
        return Validation.string(formatMessage({ id: "admin.components.cardImage.cardImageSchema.validation.string" }));
    };
    Object.defineProperty(CardImageUpload.prototype, "value", {
        get: function () {
            var _a = this.props, benefit = _a.benefit, property = _a.property;
            return benefit[property];
        },
        enumerable: false,
        configurable: true
    });
    CardImageUpload.prototype.render = function () {
        var _a = this.props, benefit = _a.benefit, onChange = _a.onChange, heading = _a.heading, name = _a.name, property = _a.property, width = _a.width, height = _a.height, formatMessage = _a.formatMessage, validation = _a.validation;
        var schema = validation || this.schema;
        return React.createElement(React.Fragment, null,
            React.createElement(SectionHeading, null,
                React.createElement(FormattedMessage, { id: heading })),
            React.createElement(ErrorWrapper, null,
                React.createElement(Hidden, { name: name, value: this.value, validation: schema(formatMessage) })),
            React.createElement(UploadedImage, { benefit: benefit, onDelete: onChange, property: property }),
            React.createElement(UploadImage, { id: id(property, this.props), property: property, onChange: onChange, dimensions: { width: width, height: height } }));
    };
    return CardImageUpload;
}(Component));
export default injectIntl(CardImageUpload);
